import Model from '@base/BaseModel'
import ApiModule from '@api/apiModule'
import { UtilDevice } from '@iskytrip/sdk'

const MODULE = ApiModule.WIRELESS

const debugHeader = { channelSource: '100' }

class DebugModel extends Model {
	constructor(props = {}) {
		super(props)
		this.setHeader(debugHeader)
	}
}

const BaseModel = UtilDevice.isApp() ? Model : DebugModel

export class GetBookingTransferApi extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = MODULE
		this.url = '/transfer/bookingTransfer'
		this.desc = '预定接送机'
	}
}

export class GetBookConfirmApi extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = MODULE
		this.url = '/transfer/getBookConfirm'
		this.desc = '获取预定确认页信息'
	}
}

export class GetBookingResultApi extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = MODULE
		this.url = '/transfer/getBookingResult'
		this.desc = '查询预定结果'
	}
}

export class GetOrderDetailApi extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = MODULE
		this.url = '/transfer/getOrderDetail'
		this.desc = '获取接送机订单详情信息'
	}
}

export class GetOrderRefundConfirmApi extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = MODULE
		this.url = '/transfer/getOrderRefundConfirm'
		this.desc = '查询订单可退信息'
	}
}

export class QueryTransferPriceApi extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = MODULE
		this.url = '/transfer/queryTransferPrice'
		this.desc = '接送机价格查询'
	}
}

export class RefundTransferOrderApi extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = MODULE
		this.url = '/transfer/refundTransferOrder'
		this.desc = '接送机订单退款'
	}
}

export class SearchAddressApi extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = MODULE
		this.url = '/transfer/searchAddress'
		this.desc = '地址联想'
	}
}

export class GetFlightsApi extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = MODULE
		this.url = '/flight-follow/getFlights'
		this.desc = '查询航班信息列表'
	}
}
